


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'PerformanceRegionMinNightStayDiagram',
  components: {},
})
export default class PerformanceRegionMinNightStayDiagram extends Vue {
  @Prop() protected values!: any;

  protected get maxValue() {
    const percents: number[] = this.values
      .map(({ value }: any) => value);
    return Math.max(...percents);
  }

  protected getRectWidth(item: any) {
    return 100 / this.maxValue * item.value;
  }

  protected getRectOpacity(item: any) {
    return Number(this.getRectWidth(item) / 100).toFixed(2);
  }
}
